"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.$delete = $delete;
exports.$get = $get;
exports.$getZip = $getZip;
exports.$post = $post;
exports.$put = $put;
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _vue = _interopRequireDefault(require("vue"));
var _axios = _interopRequireDefault(require("axios"));
var _elementUi = require("element-ui");
var _store = _interopRequireDefault(require("@/store"));
var _auth = require("@/utils/auth");
var _adminOperationReport = require("@/utils/adminOperationReport");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /**
 * 【操作埋点】2026-05-25
 * 说明：响应拦截器在业务请求成功后触发 triggerAdminOperationReportAfterSuccess；
 * $post/$put/$delete 第三参数经 normalizeReportMetaOption 写入 config.adminOperationReport
 */
var pending = []; //声明一个数组用于存储每个ajax请求的取消函数和ajax标识
var cancelToken = _axios.default.CancelToken; //初始化取消请求的构造函数
var removePending = function removePending(flagUrl, f) {
  if (pending.indexOf(flagUrl) !== -1) {
    if (f) {
      (0, _elementUi.Message)({
        message: '按钮点击太频繁',
        type: 'error'
      });
    } else {
      pending.splice(pending.indexOf(flagUrl), 1);
    }
  } else {
    if (f) {
      pending.push(flagUrl);
    }
  }
};

// create an axios instance
var service = _axios.default.create({
  baseURL: _vue.default.prototype.BASE_URL,
  // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 60000 // request timeout
});
//service.defaults.withCredentials = true // 跨域
// request interceptor
service.interceptors.request.use(function (config) {
  // do something before request is sent
  if (_store.default.getters.token) {
    // let each request carry token
    // ['X-Token'] is a custom headers key
    // please modify it according to the actual situation

    //config.headers['user_id'] = getToken('user_id')
  }
  config.baseURL = _vue.default.prototype.BASE_URL;
  return config;
}, function (error) {
  // do something with request error
  console.log(error); // for debug
  return Promise.reject(error);
});
service.interceptors.response.use(function (res) {
  if (res.headers['content-type'] === 'image/jpeg') {
    return Promise.resolve(res.data);
  }
  if (res.request.responseType === 'blob') {
    return res.data;
  }
  switch (parseInt(res.data.code)) {
    case 0:
      try {
        (0, _adminOperationReport.triggerAdminOperationReportAfterSuccess)(res);
      } catch (e) {
        /* 埋点失败不影响业务 */
      }
      if (res.data.data) {
        return Promise.resolve(res.data.data);
      } else {
        return Promise.resolve(res.data);
      }
    default:
      _elementUi.Message.closeAll();
      console.log(res);
      if (res.data.msg == '登陆已过期，请重新登陆' || res.data.msg == '验证失败，无效的token') {
        (0, _elementUi.Message)({
          message: res.data.msg || '网络卡住了，请刷新1',
          type: 'error'
        });
        location.href = '/home';
      } else {
        (0, _elementUi.Message)({
          message: res.data.msg || '网络卡住了，请刷新2',
          type: 'error'
        });
        return Promise.reject(res.data);
      }
  }
}, function (error) {
  if (error.message && error.message.indexOf('timeout of') > -1) {
    location.reload();
  } else {
    _elementUi.Message.closeAll();
    if (!error.response) {
      (0, _elementUi.Message)({
        message: '网络卡住了，请刷新3',
        type: 'error'
      });
    }
    if (error.code == 'ECONNABORTED' && error.message.indexOf('timeout') != -1) {
      (0, _elementUi.Message)({
        message: '网络卡住了，请刷新4',
        type: 'error'
      });
    }
  }
  return Promise.reject(error);
});
function $get(url) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  params.token = (0, _auth.getToken)();
  params.user_id = (0, _auth.getToken)('user_id');
  params.agent_id = params.agent_id || (0, _auth.getToken)('agent_id');
  return service.get(url, {
    params: params
  });
}
function $getZip(url) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  params.token = (0, _auth.getToken)();
  params.user_id = (0, _auth.getToken)('user_id');
  params.agent_id = params.agent_id || (0, _auth.getToken)('agent_id');
  return service.get(url, {
    responseType: 'blob',
    params: params,
    headers: {
      'Content-Type': 'application/json; application/octet-stream'
    }
  });
}

/**
 * @param {Object} [reportMeta] 可选埋点：{ operation_option, content }；传 false 则不上报
 */
function $post(url) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var reportMeta = arguments.length > 2 ? arguments[2] : undefined;
  var reportOpts = (0, _adminOperationReport.normalizeReportMetaOption)(reportMeta);
  url = url + '?token=' + (0, _auth.getToken)();
  data.token = (0, _auth.getToken)();
  data.user_id = (0, _auth.getToken)('user_id');
  data.agent_id = data.tagent_id || (0, _auth.getToken)('agent_id');
  return service.post(url, data, reportOpts);
}

// delete方法
function $delete(url) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var reportMeta = arguments.length > 2 ? arguments[2] : undefined;
  var reportOpts = (0, _adminOperationReport.normalizeReportMetaOption)(reportMeta);
  var fullUrl = url + '?token=' + (0, _auth.getToken)() + '&user_id=' + (0, _auth.getToken)('user_id') + '&agent_id=' + (0, _auth.getToken)('agent_id');
  return service.delete(fullUrl, _objectSpread({
    params: params
  }, reportOpts));
}

// put方法
function $put(url) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var reportMeta = arguments.length > 2 ? arguments[2] : undefined;
  var reportOpts = (0, _adminOperationReport.normalizeReportMetaOption)(reportMeta);
  var fullUrl = url + '?token=' + (0, _auth.getToken)() + '&user_id=' + (0, _auth.getToken)('user_id') + '&agent_id=' + (0, _auth.getToken)('agent_id');
  return service.put(fullUrl, data, reportOpts);
}
var _default = exports.default = service;